import * as Icon from '../../components/icons';

const DashboardAppsComponent = () => {
  return (
    <>
      <div className='flex flex-col gap-y-6 sm:flex-row'>
        <div
          className='border-gray-tertiary mr-8 flex h-32 w-full cursor-pointer rounded-lg border bg-white max-md:relative sm:w-60'
          onClick={() => (window.location.href = import.meta.env.VITE_SKEZIA_APP_HOST)}
        >
          <Icon.Skezia className='m-auto scale-125' />
          <div className='border-blue-primary text-blue-primary absolute bottom-3 left-[1.1rem] border-b md:hidden'>
            Accéder à la solution
          </div>
        </div>
        <div
          className='border-gray-tertiary flex h-32 w-full cursor-pointer rounded-lg border bg-white max-md:relative sm:w-60'
          onClick={() => (window.location.href = `${import.meta.env.VITE_SKEMEET_APP_HOST}/p/patients`)}
        >
          <Icon.Skemeet className='m-auto scale-125' />
          <div className='border-blue-primary text-blue-primary absolute bottom-3 left-[1.1rem] border-b md:hidden'>
            Accéder à la solution
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardAppsComponent;
